import 'owl.carousel';

$(document).ready(function() {

    //Carrousel
    let owl = $(".owl-carousel");
    let dots = owl.find('.owl-dot');
    let refreshWindow = function(e) {
        e.stopPropagation();
        // window.dispatchEvent(new Event('resize'));
        //For IE
        let event = document.createEvent("Event");
        event.initEvent("resize", false, true);
        window.dispatchEvent(event);
    };

    let owlInstance = owl.owlCarousel(
        {
            dots: false,
            loop: true,
            center: true,
            margin: 0,
            autoplay: true,
            smartSpeed: 500,
            mouseDrag: false,
            items: 8,
            autoplayTimeout: 8000,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:2
                },
                1200:{
                    items:3
                },
                1400:{
                    items:4
                },
                1600:{
                    items:8
                }
            }
        }
    );

    // owl.on('translated.owl.carousel', refreshWindow);
    // $(owl[1]).data('owl.carousel').options.autoplayTimeout = 3100;
    // owl.trigger('stop.owl.autoplay');

    //Refresh carousel on resize window
    // $(window).on('resize', debounce(function() {
    //     owlInstance.trigger('refresh.owl.carousel');
    // }, 400));

    //Gestion de chaque item
    let items = owl.find('.item');
    let duration = 400;
    let longDuration = 900;
    let animated = null

    items.each(function() {

        let target = $($(this).parents('.owl-carousel').data('target'));
        let content = $(this).find('.content');
        let _self = this;

        this.hideVignette = function(element, others = null) {

            //Remove class active vignette
            element.removeClass('active');
            //On reprend le carousel
            owl.trigger('play.owl.autoplay');
            owl.trigger('refresh.owl.carousel');

            //Parent
            if(target.length) {

                //Gestion du contenu à afficher
                if(content.length) {

                    let targetContent = target.find('.content');
                    if(targetContent.length) {

                        targetContent.removeClass('active');
                        setTimeout(() => {
                            targetContent.slideUp(duration).remove();
                        }, longDuration);
                    }
                }

                //Réaparition du texte d'intro
                setTimeout(() => {

                    target.removeClass('inview').find('> *:not(.content)').fadeIn({duration: duration, queue: false}).slideDown({duration: duration, queue: false});
                    //Réinitialisation du click sur l'élément
                    animated = null;
                }, longDuration);
            }
            else {
                //Réinitialisation du click sur l'élément
                animated = null;
            }
        };

        this.hideOthers = function(element) {

            animated = true;
            element.removeClass('active');
            //Parent
            if(target.length) {

                let targetContent = target.find('.content');
                if(targetContent.length) {
                    targetContent.removeClass('active');
                }
            }
        };

        this.showVignette = function(element, others = null) {

            element.addClass('active');
            //On arrête le carousel
            owl.trigger('stop.owl.autoplay');

            let hideParent = (delay = 0) => {
                target.addClass('inview').find('> *:not(.content)').fadeOut({duration: duration + (delay)});
            }

            let displayContent = () => {

                setTimeout(() => {

                    let htmlContent = content.html();
                    let html = htmlContent.replace('data-src', 'src');
                    let targetContent = target.find('.content');

                    if(targetContent.length) {

                        hideParent();
                        //Animation du contenu (apparition)
                        setTimeout(() => {

                            targetContent.html(html);
                            setTimeout(() => {
                                targetContent.addClass('active');
                            }, 100);
                        }, longDuration);

                    }
                    else {

                        target.prepend(`<div class="content">${html}</div>`)
                        target.find('.content').show(0, function() {

                            hideParent();
                            $(this).addClass('active');
                        });

                    }

                    //Réinitialisation du click sur l'élément
                    animated = null;
                }, duration);
            };

            $('html').animate({scrollTop: 0, duration: 400}, false, false, () => {

                //Parent
                if(target.length) {

                    //Gestion du contenu à afficher
                    if(content.length) {
                        //Disparition du texte d'intro + display content
                        displayContent();
                    }
                    else {
                        //Réinitialisation du click sur l'élément
                        animated = null;
                    }
                }
            });

        };

        $(this).click(function(e) {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if(animated) return false;
            let hasClass = $(this).hasClass('active');
            let others = items.not($(this));

            //Load img in each item (lazyload)
            if(!this.hasOwnProperty('loadImg')) {

                items.each(function() {
                    $(this).html(
                        $(this).html().replace('data-src', 'src')
                    );
                    this.loadImg = true;
                });
            }

            //Réinitialisation des autres éléments
            this.hideOthers(others);

            if(hasClass) //Désactivation de l'item
                this.hideVignette($(this), others);
            else //Activation de l'item
                this.showVignette($(this), others);
        });
    });

});

let timer = null;
function debounce(callback, delay, local) { //Attend un certain delais pour exécuter une fonction

    // var timer; // Static variable
    var delay = delay || 0;
    return function() {

        var self = this, //Get context
        args = arguments;

        clearTimeout(timer);
        timer = setTimeout(function() {
            return callback.apply(self, args);
        }, delay);
    }
}



// WEBPACK FOOTER //
// ./js/modules/owlCarousel.js